export default {"src":"/_next/static/media/404-dark.4ac16b0a.svg","height":600,"width":900,"blurWidth":0,"blurHeight":0};